import React from 'react'
import ToolbarMail from '../../Includes/Toolbar/ToolbarMail'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  variables
} from '../../../Variables/Variables'
import {
  SET_PLAQUETTE,
  SEND_MAIL_PLAQUETTE
} from '../../../Redux/Actions/Plaquette'

const PlaquetteToolbar = () => {
  const dispatch = useDispatch()
  const mails = useSelector(state => state.plaquette.mails)
  const pending = useSelector(state => state.plaquette.pending)
  const Commit = () => {
    dispatch(SET_PLAQUETTE('pending', true))
    dispatch(SEND_MAIL_PLAQUETTE(
      mails,
      () => {
        dispatch(SET_PLAQUETTE('input', ''))
        dispatch(SET_PLAQUETTE('mails', []))
        dispatch(SET_PLAQUETTE('error', false))
        dispatch(SET_PLAQUETTE('pending', false))
      }
    ))
  }
  return (
    <ToolbarMail
      data-testid="plaquette-envoyer"
      mails={mails}
      onClick={() => Commit()}
      titre="Envoyer une plaquette"
      disabled={(
        (pending) ||
        (mails.length === 0) ||
        (mails.length > variables.mail.maximum)
      )}
    />
  )
}

export default PlaquetteToolbar
